var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicdisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.036,
    height: 23,
    viewBox: "0 0 24.036 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "micdisabled"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30255",
    "data-name": "Rectangle 30255",
    width: 23,
    height: 23,
    transform: "translate(279 685)",
    fill: "#382464",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85964",
    "data-name": "Group 85964",
    transform: "translate(-313.482 -689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_855",
    "data-name": "Mask Group 855",
    transform: "translate(35 4)",
    clipPath: "url(#micdisabled)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-08-22T145004.935",
    "data-name": "svgexport-6 - 2022-08-22T145004.935",
    transform: "translate(284.074 686.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85904",
    "data-name": "Group 85904",
    transform: "translate(0 9.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85903",
    "data-name": "Group 85903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47954",
    "data-name": "Path 47954",
    d: "M18.241,15.156a.708.708,0,1,0-1.416,0,5.01,5.01,0,0,1-10.02,0,.708.708,0,0,0-1.416,0,6.433,6.433,0,0,0,5.718,6.386V23.43H8.532a.708.708,0,1,0,0,1.416H15.1a.708.708,0,1,0,0-1.416H12.522V21.542A6.433,6.433,0,0,0,18.241,15.156Z",
    transform: "translate(-5.388 -14.448)",
    fill: "#382464"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85906",
    "data-name": "Group 85906",
    transform: "translate(2.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85905",
    "data-name": "Group 85905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47955",
    "data-name": "Path 47955",
    d: "M13.043,0A3.948,3.948,0,0,0,9.095,3.948v6.393a3.948,3.948,0,1,0,7.9,0V3.948A3.948,3.948,0,0,0,13.043,0Z",
    transform: "translate(-9.095)",
    fill: "#382464"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Path_47983",
    "data-name": "Path 47983",
    transform: "translate(314.846 689.198) rotate(43)",
    fill: "#382464"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.70000076293945 1.700000047683716 L 0.300000011920929 1.700000047683716 L 0.300000011920929 0.300000011920929 L 30.70000076293945 0.300000011920929 L 30.70000076293945 1.700000047683716 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.6000003814697266 0.6000000238418579 L 0.6000003814697266 1.399999976158142 L 30.39999961853027 1.399999976158142 L 30.39999961853027 0.6000000238418579 L 0.6000003814697266 0.6000000238418579 M 0 0 L 31 0 L 31 2 L 0 2 L 0 0 Z",
    stroke: "none",
    fill: "#f5f5f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicdisabled);
export default __webpack_public_path__ + "static/media/micdisabled.65130bbb6fcfb1ba783399ae7d4d34a1.svg";
export { ForwardRef as ReactComponent };